
const validate = (experience = {}) => {
    const errors = []
    if( !experience.name) {
        errors.push('An experience title must be set.')
    }

    if( !experience.date) {
        errors.push('An experience date must be set.')
    }

    if( !experience.facilitatorId) {
        errors.push('An experience facilitator must be set.')
    }

    if( !experience.locationId) {
        errors.push('An experience location must be set.')
    }

    if( !experience.hourId) {
        errors.push('An experience hour must be set.')
    }

    if( !experience.durationId) {
        errors.push('An experience duration must be set.')
    }

    return errors.length ? errors : null
}

export default validate
